import React from "react"
import { Col, Row, Card, CardBody, Label } from "reactstrap"
import { formatDateTime, uId } from "common/utility"
import "./dealer-order.scss"
import { formatNumberWithCommas } from "../../common/utility"
import { useNavigate } from 'react-router-dom';
import { Tooltip } from "react-tooltip"

const OrderContainer = props => {
  const { orderList, toggleModal, handleChangeOrderId, trackingUrl, orderReasonOptions } = props
  const navigate = useNavigate()
  const ensureHttps = url => {
    if (url && !url.startsWith("https://")) {
      return `https://${url}`
    }
    return url
  }

  return orderList.map((order) => {
    return (
      <div className="mb-3 order" key={uId()}>
        <Card>
          <CardBody>
            <Row className="justify-content-between"></Row>
            <Row>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">
                    Order ID
                  </Label>
                  <p>{order.orderCode}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">
                    SAP Order ID
                  </Label>
                  <p>{order?.sapOrderId || '-'}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">Order Request ID</Label>
                  <p>{order['requestOrder.orderCode']}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">Date</Label>
                  <p>{formatDateTime(order.orderDate)}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">Total Amount</Label>
                  <p >
                    {formatNumberWithCommas(order.totalAmount)}
                  </p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">
                    Plant
                  </Label>
                  <p data-tooltip-id={`plant-tooltip${order.id}`}>
                    {order?.plantDescription?.length > 20
                      ? `${order.plantDescription?.substring(0, 20)}...`
                      : order.plantDescription || "NA"}
                  </p>
                  <Tooltip
                    style={{ maxWidth: "200px", marginLeft: "1rem" }}
                    id={`plant-tooltip${order.id}`}
                    place="top"
                    content={order?.plantDescription}
                  />
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">
                    Payment Terms
                  </Label>
                  <p data-tooltip-id={`payment-tooltip${order.id}`}>
                    {order?.paymentTermsDescription?.length > 20
                      ? `${order.paymentTermsDescription?.substring(0, 20)}...`
                      : order.paymentTermsDescription || "NA"}
                  </p>
                  <Tooltip
                    style={{ maxWidth: "200px", marginLeft: "1rem" }}
                    id={`payment-tooltip${order.id}`}
                    place="top"
                    content={order?.paymentTermsDescription}
                  />
                </div>
              </Col>

              <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                <div className="mb-3">
                  <Label htmlFor="dealerType" className="label-styling">
                    Order Reason
                  </Label>
                  <p>
                    {(() => {
                      const found = orderReasonOptions?.find(opt => opt.value === order?.orderReason);
                      return found ? `${found.label}` : '-';
                    })()}
                  </p>
                </div>
              </Col>

              <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                <div className="mb-3">
                  <Label htmlFor="shipToParty" className="label-styling">
                    Ship to Party
                  </Label>
                  <p>{order?.shipToParty || '-'}</p>
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">
                    Tracking Details
                  </Label>
                  {trackingUrl[order.id] ? (
                    <p
                      data-tooltip-id={`tracking-tooltip${order.id}`}
                    >
                      {trackingUrl[order.id]?.length > 20 ?
                        trackingUrl[order.id]?.substring(0, 20) + "..." : trackingUrl[order.id]
                      }
                    </p>
                  ) : (
                    <p

                    >
                      NA
                    </p>

                  )}
                  <Tooltip
                    style={{ maxWidth: "500px", marginLeft: "1rem" }}
                    id={`tracking-tooltip${order.id}`}
                    place="top"
                    content={trackingUrl[order.id]}
                  />
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">

                    No of products
                  </Label>
                  <p className="lh-1">
                    {order['orderedProducts.orderCount'] || "-"}
                  </p>
                </div>
              </Col>
              <Col xs="6" md="2" className="mb-2">
                <div className="d-flex flex-row justify-content-between pe-5 ">
                  <div>
                    <Label htmlFor="dealerType" className="color-label mb-0 fw-bold text-secondary">

                      Status</Label>{" "}
                    <p
                      className={`py-1 mb-2  text-capitalize ${order.orderStatus === "pending" ||
                        order.orderStatus === "processing"
                        ? "bg-warning rounded-pill text-white px-2"
                        : order.orderStatus === "cancelled" ||
                          order.orderStatus === "rejected"
                          ? "bg-danger rounded-pill text-white px-2"
                          : "bg-green rounded-pill text-white px-2"
                        }`}
                    >
                      {order.orderStatus}
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs="6" md="2">
                <button
                  className="btn btn-outline-success fw-bold me-2"
                  onClick={() => {
                    navigate(`/customer/orders/${order.id}`)
                  }}
                >
                  <i className="mdi mdi-eye me-2" />
                  View Details
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    )
  })
}

export default OrderContainer
